import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: () => import('../layout/index.vue'),
    redirect: '/job',
    children: [
      {
        path: 'job',
        name: 'Job',
        component: () => import('../views/job/index.vue'),
        meta: { title: '岗位管理' }
      },
      {
        path: 'lead',
        name: 'Lead',
        component: () => import('../views/lead/index.vue'),
        meta: { title: '信息管理' }
      },
      {
        path: 'contact',
        name: 'Contact',
        component: () => import('../views/contact/index.vue'),
        meta: { title: '客服配置' }
      },
      {
        path: 'promotion',
        name: 'Promotion',
        component: () => import('../views/promotion/index.vue'),
        meta: { title: '推广监控' }
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
